import { getLocalStorage } from "util/storageUtil";
let baseUrl = import.meta.env.REACT_APP_SERVER_URL;
if (window?.location?.host?.includes("preview")) {
  baseUrl = import.meta.env.REACT_APP_FLIP_SERVER_URL;
}
const serverURL = baseUrl + "/cms/api";
const serverURL_PAX = baseUrl + "/pax";
const fisURL = baseUrl + "/fis/v2/api";
const cmsURL = import.meta.env.REACT_APP_CMS_URL + "/api";
const campaignURL = import.meta.env.REACT_APP_CAMPAIGN_URL;
const v2ServerURL = baseUrl + "/pax2";

export const S3_BASE_URL = import.meta.env.REACT_APP_S3_BASE_URL;

//**Env*/
export const ENV = import.meta.env.REACT_APP_ENVIRONMENT;
export const gatewayURL = baseUrl;

export const CDN_URL = import.meta.env.REACT_APP_CDN_URL;
export const PRODUCT_CDN_URL = import.meta.env.REACT_APP_PRODUCT_CDN_URL;
export const SHOP_CDN_URL = import.meta.env.REACT_APP_SHOP_CDN_URL;
export const AIRLINE_CDN_URL = import.meta.env.REACT_APP_AIRLINE_CDN_URL;

export const GOOGLE_RECAPTCHA_SITE_KEY =
  import.meta.env.REACT_APP_RECAPTCHA_SITE_KEY;

export const GOOGLE_RECAPTCHA_ENTERPRISE_ENABLED =
  import.meta.env.REACT_APP_GOOGLE_RECAPTCHA_ENTERPRISE_ENABLED === "true";

export const ACCESSIBILITY_WIDGET_CLIENT_ID =
  import.meta.env.REACT_APP_ACCESSIBILITY_WIDGET_CLIENT_ID;

export const WEBSOCKET_URL = import.meta.env.REACT_APP_WEBSOCKET_URL;
//export const OTP_BASED_LOGIN = import.meta.env.REACT_APP_SHOW_OTP_BASED_LOGIN ?? 0;
export const AIRPORT_COORDINATE_RADIUS =
  import.meta.env.REACT_APP_AIRPORT_COORDINATE_RADIUS || 1000;

export const LOUNGE_COORDINATE_RADIUS =
  import.meta.env.REACT_APP_LOUNGE_COORDINATE_RADIUS || 500;
export const S3_URL = import.meta.env.REACT_APP_S3_URL;
export const FRESH_DESK_API_KEY = import.meta.env.REACT_APP_FRESH_DESK_API_KEY;
export const QR_PREFIX_LOUNGE = import.meta.env.REACT_APP_QR_PREFIX_LOUNGE;
export const LOGIN_COOKIE_DOMAIN = import.meta.env.REACT_APP_LOGIN_COOKIE_DOMAIN;
export const DEVNAGRI_KEY = import.meta.env.REACT_APP_DEVNAGRI_KEY;
export const defaultLoginPhNo = import.meta.env.REACT_APP_DEFAULT_LOGIN_PH_NO;
export const defaultLoginEmail = import.meta.env.REACT_APP_DEFAULT_LOGIN_EMAIL;
export const PAYMENT_AUTHORIZATION_INFO =
  import.meta.env.REACT_APP_PAYMENT_AUTHORIZATION_INFO;
export const SENTRY_ENABLED = import.meta.env.REACT_APP_SENTRY_ENABLED;
export const SENTRY_DSN = import.meta.env.REACT_APP_SENTRY_DSN;

const configObj = getLocalStorage("appConfig") || {};
let secondaryGatewayUrl = configObj?.gatewayURL || gatewayURL;
if (window?.location?.host?.includes("preview")) {
  secondaryGatewayUrl = import.meta.env.REACT_APP_FLIP_SERVER_URL;
}

export const PLATFORM = configObj?.platform;

export const config = {
  api: {
    // bialApiList starts=======
    serviceListingBial:
      "https://dev-gateway.bengaluruairport.com/pax2/v2/api/service/list",
    serviceCategoriesBial:
      "https://dev-gateway.bengaluruairport.com/pax2/v2/api/service/category",
    serviceVariantsBial: `${gatewayURL}/pax2/v2/api/service/variant`,
    // "https://dev-gateway.bengaluruairport.com/pax2/v2/api/service/variant",
    serviceGrandAncestorBial: `${gatewayURL}/pax2/v2/api/service/grandAncestor`,
    // "https://dev-gateway.bengaluruairport.com/pax2/v2/api/service/grandAncestor",
    // bialApiListEnds ======
    updateDocument: `${gatewayURL}/gw/api/user/update/documents`,
    amenitiesList: `${gatewayURL}/pax2/v2/api/service/category`,
    chatBotSearch: `${v2ServerURL}/v2/api/chatbot/process`,
    homepage: `${serverURL}/homepages`,
    homepageStores: `${serverURL_PAX}/api/getStores?page=0&limit=150&isHomePage=true`,
    navbar: `${serverURL}/navbars`,
    pages: `${serverURL}/pages/{{pageId}}`,
    campaignPages: `${serverURL}/campaigns/{{pageId}}`,
    footer: `${serverURL}/footer-v2s?populate[logo]=*&populate[secondaryLogo]=*&populate[DownloadLinks]=*&populate[SocialMedia][populate][logo]=*&populate[NavigationLinks][populate][image]=*&populate[NavigationLinks][populate][pages]=*&populate[OtherLinks]=true&populate[LogoList][populate][Image]=*`,
    weather: `${serverURL}/weathers`,
    flightNumberMaster: `${fisURL}/aodb/flight-infos`,
    flightInfo: `${fisURL}/aodb/flight-infos/{{date}}/{{movementType}}`,
    flightSearch: `${fisURL}/aodb/flight-info/{{date}}/{{movementType}}/{{flightNo}}`,
    flightSearchBaseAirport: `${fisURL}/aodb/flight-info/{{date}}/{{movementType}}/{{flightNo}}/{{baseAirport}}`,
    profileInterest: `${serverURL}/profile-interests`,
    profileInfo: `${serverURL}/profiles/{{userId}}`,
    vayuVajraStops: `${serverURL}/vayuvajras/stops`,
    vayuVajraServices: `${serverURL}/vayuvajras/services`,
    vayuVajraServicesSearch: `${serverURL}/vayuvajras/search`,
    flyBusStops: `${serverURL}/flybuses/stops`,
    flyBusSearch: `${serverURL}/flybuses/search`,
    lostAndFoundSearch: `${serverURL}/lost-and-founds/search`,
    claimSubmit: `${serverURL}/lost-and-founds/claim`,
    feedback: `${serverURL}/lost-and-founds/feedback`,
    tendersList: `${serverURL}/tenders`,
    tendersSearch: `${serverURL}/tenders/search`,
    tendersCategory: `${serverURL}/tender-categories`,
    tendersDownload: `${serverURL}/tenders/download`,
    tendersDocUpload: `${serverURL}/tenders/bid`,
    googleSignIn: `${serverURL}/connect/google`,
    fbSignIn: `${serverURL}/connect/facebook`,
    twitterSignIn: `${serverURL}/connect/twitter`,
    sugesstionSearch: `${gatewayURL}/gw/api/search/v3/suggestions`,
    globalSearch: `${gatewayURL}/gw/api/search/v2/all`,
    userFeedback: `${serverURL}/feedbacks`,
    estimatedWaitTime: `${fisURL}/qms/status?selection=summary`,
    flightTrack: `${fisURL}/flightAlert/create`,
    stopFlightTrack: `${fisURL}/flightAlert/stop`,
    getFlightTrackData: `${fisURL}/flightAlert/getData`,
    validateOtp_v2: `${v2ServerURL}/v2/api/user/validateOtp`,
    genOtp_v2: `${v2ServerURL}/v2/api/user/genOtp`,
    register: `${gatewayURL}/pax2/v2/api/user/register`,
    validateRegistration: `${gatewayURL}/pax2/v2/api/user/validateToReg`,
    serviceListing: `${gatewayURL}/pax2/v2/api/service/list`,
    serviceCategories: `${gatewayURL}/pax2/v2/api/service/category`,
    campaignConfig: `${campaignURL}/campaign/getconfigdata?key=jpPXrzgiXyE3FdwKT7OiYQ==`,
    getRaffles: `${campaignURL}/campaign/raffles/{{user_id}}?key=jpPXrzgiXyE3FdwKT7OiYQ==`,

    // ServiceDetails
    serviceVariants: `${gatewayURL}/pax2/v2/api/service/variant`,
    serviceInfo: `${gatewayURL}/pax2/v2/api/service/info`,
    serviceGrandAncestor: `${gatewayURL}/pax2/v2/api/service/grandAncestor`,

    // promotion
    getCoupons: `${secondaryGatewayUrl}/promotions/v1/api/promotion/getCoupons`,

    //flights
    homeAirports: `${fisURL}/aodb/homeAirports`,
    flightListing: `${fisURL}/aodb/flights`,
    airportSearchResults: `${fisURL}/aodb/airports`,
    campaignRegister: `${gatewayURL}/pax2/v2/api/campaign/register`,
    campaignRegisterList: `${gatewayURL}/pax2/v2/api/campaign/getRegData`,
    campaignValidation: `${gatewayURL}/pax2/v2/api/campaign/approve`,
    landingPageConstruct: `${gatewayURL}/pax2/v2/api/products/landingPage`,
    feedback_v2: {
      save: {
        overall: `${gatewayURL}/feedback/api/save/overall`,
      },
    },
    login: {
      social: {
        google: `${gatewayURL}/login/google`,
        facebook: `${gatewayURL}/login/facebook`,
        twitter: `${gatewayURL}/login/twitter`,
      },
      local: `${secondaryGatewayUrl}/login/local`,
      otp: `${secondaryGatewayUrl}/login/otp`,
      refresh: `${secondaryGatewayUrl}/login/refresh`,
    },
    logout: `${secondaryGatewayUrl}/gw/api/logout`,
    user: {
      info: `${secondaryGatewayUrl}/gw/api/user/info`,
      update: `${secondaryGatewayUrl}/pax2/v2/api/user/updateUser`,
      updateAccount: `${secondaryGatewayUrl}/pax2/v2/api/user/updateAccount`,
      updateProfileImage: `${secondaryGatewayUrl}/pax2/v2/api/user/image/profile/save`,
      delete: `${secondaryGatewayUrl}/gw/api/user/delete`,
      referral_check: `${secondaryGatewayUrl}/pax2/v2/api/user/lms/referral/check`,
      become_member: `${secondaryGatewayUrl}/pax2/v2/api/user/lms/membership/apply`,
      membership_status: `${secondaryGatewayUrl}/pax2/v2/api/user/lms/membership/status`,
      requestOtpUpdateEmail: `${secondaryGatewayUrl}/gw/api/user/request/update/email/:email`,
      updateEmail: `${secondaryGatewayUrl}/gw/api/user/update/email`,
      requestOtpUpdateMobile: `${secondaryGatewayUrl}/gw/api/user/request/update/mobile/:mobile`,
      updateMobile: `/gw/api/user/update/mobile`,
      communication: {
        channels: `${secondaryGatewayUrl}/pax2/v2/api/user/communication/channels`,
        preferences: `${secondaryGatewayUrl}/pax2/v2/api/user/communication/preferences`,
      },
    },
    addNewFlights: {
      flightListing: `${fisURL}/aodb/flights`,
      homeAirports: `${fisURL}/aodb/homeAirports`,
      airportSearchResults: `${fisURL}/aodb/airports`,
      airportSearchResultsBial: `${fisURL}/aodb/airports`,
      flightListingBial: `${fisURL}/aodb/flights`,
      // flightListingBial: "https://dev-gateway.bengaluruairport.com/fis/v2/api/aodb/flights",
      // airportSearchResultsBial: "https://dev-gateway.bengaluruairport.com/fis/v2/api/aodb/airports",

      flightLocate: `${fisURL}/aodb/flight/track?aircraftRegNo=`,
      addFlight: `${gatewayURL}/pax2/v2/api/user/flight`,
      myFlights: `${gatewayURL}/pax2/v2/api/user/flight`,
      removeFlight: `${gatewayURL}/pax2/v2/api/user/flight`,
    },
    cart: {
      // V2
      summary: `${secondaryGatewayUrl}/pax2/v2/api/cart/summary`,
      myCartV2: `${secondaryGatewayUrl}/pax2/v2/api/cart/v2/mycart`,
      saveCartV2: `${secondaryGatewayUrl}/pax2/v2/api/cart/v2/save`,
    },
    moreInfo: {
      moreInfo: `${gatewayURL}/pax2/v2/api/service/mandatoryfields`,
    },
    payment: {
      gatewayConfiguration: `${secondaryGatewayUrl}/pax2/v2/api/payment/gatewayConfiguration`,
      completeOrder: `${secondaryGatewayUrl}/pax2/v2/api/order/complete`,
      orderSummaryV2: `${secondaryGatewayUrl}/pax2/v2/api/order/summary`,
      // Order-status polling: GET <orderStatus>/:orderId (orderId is a PATH param,
      // the accountid header comes from headerParams via callAPI). BE service path
      // is /v2/api/order/orderStatus/:orderId; the /pax2 gateway prefix here follows
      // the other order APIs - TODO(order-recovery): confirm the gateway route.
      // orderSummaryV2 above stays the one-shot source for items/price/metadata.
      // See src/pages/orderRecovery/useOrderStatusPolling.js.
      orderStatus: `${secondaryGatewayUrl}/pax2/v2/api/order/orderStatus`,
      // GET <alternateStores>/:orderId - stores to suggest when an order fails
      // ("Explore Similar Stores").
      alternateStores: `${secondaryGatewayUrl}/pax2/v2/api/order/alternateStores`,
      // POST { orderId } - new payment session on the SAME unpaid order (SKTB-2750);
      // 3 payment attempts per order in total, enforced by the backend.
      retryPayment: `${secondaryGatewayUrl}/pax2/v2/api/order/retryPayment`,
    },
    checkout: {
      // V2
      checkoutV2: `${secondaryGatewayUrl}/pax2/v2/api/cart/v2/checkout`,
    },
    guest: {
      guestLogin: `${gatewayURL}/login/guest`,
      updateUser: `${gatewayURL}/pax2/v2/api/user/updateUser`,
      updatePaxDetails: `${secondaryGatewayUrl}/pax2/v2/api/order/addPax`,
    },
    captive: {
      getOtp: `${secondaryGatewayUrl}/login/captive/otp`,
      local: `${secondaryGatewayUrl}/login/captive/local`,
    },
    myOrders: {
      activeOrders: `${secondaryGatewayUrl}/pax2/v2/api/order/active`,
      pastOrders: `${secondaryGatewayUrl}/pax2/v2/api/order/past`,
      cancelService: `${secondaryGatewayUrl}/pax2/v2/api/order/cancel`,
      locationFilter: `${secondaryGatewayUrl}/pax2/v2/api/order/orderedLocations`,
    },
    permission: {
      userPermission: `${secondaryGatewayUrl}/gw/api/user/permissions/v2/{{appType}}`,
    },
    qms: {
      cumulative: `${gatewayURL}/fis/v2/api/qms/cumulative`,
      general: `${gatewayURL}/fis/v2/api/qms/general`,
    },
    flightbooking: {
      getSearchFilters: `${gatewayURL}/flightbooking/v2/api/flight/getsearchfilters`,
      getAirports: `${gatewayURL}/flightbooking/v2/api/flight/getairports`,
      searchFlight: `${gatewayURL}/flightbooking/v2/api/flight/searchflight`,
      getconvenienceconfig: `${gatewayURL}/flightbooking/v2/api/flight/getconvenienceconfig`,
    },
    flightGate: {
      gateListing: `${gatewayURL}/fis/v2/api/aodb/gates`,
    },
    products: {
      getProductsByStore: `${gatewayURL}/pax2/v2/api/products/category`,
      productDetails: `${gatewayURL}/pax2/v2/api/products/item`,
      productSearch: `${gatewayURL}/pax2/v2/api/products/search`,
      getProductId: `${gatewayURL}/pax2/v2/api/products/productId`,
      displayCollectionProducts: `${gatewayURL}/pax2/v2/api/products/landingPage`,
      getStoreDetailWithItems: `${gatewayURL}/pax2/v2/api/products/storeDisplayItems`,
      getStores: `${gatewayURL}/pax2/v2/api/shops/getStores`,
      getStoreDetail: `${gatewayURL}/pax2/v2/api/shops/getShopById`,
      getStoreConfig: `${gatewayURL}/pax2/v2/api/shops/getStoreConfig`,

      landingPageConstruct: `${gatewayURL}/pax2/v2/api/products/landingPageConstruct`,
      displayCollection: `${gatewayURL}/pax2/v2/api/products/displayCollection`,
      productListing: `${gatewayURL}/pax2/v2/api/products/list`,
      areaListing: `${gatewayURL}/pax2/v2/api/products/areaList`,
      getCategoryList: `${gatewayURL}/pax2/v2/api/products/categoryList`,
    },
    npsFeedback: {
      pendingItem: `${gatewayURL}/feedback/api/pending/item`,
      saveItem: `${gatewayURL}/feedback/api/save/item`,
      pendingRapidfire: `${gatewayURL}/feedback/api/pending/rapidfire/item`,
      saveRapidfireItem: `${gatewayURL}/feedback/api/save/rapidfire/item`,
      saveRapidfireOverall: `${gatewayURL}/feedback/api/save/rapidfire/overall`,
      askLater: `${gatewayURL}/feedback/api/later`,
    },
    eventAccess: {
      saveEmpId: `${gatewayURL}/pax2/v2/api/user/storeBialEmp`,
    },
    appEnvProps: {
      envProps: `${gatewayURL}/cms/api/config-v2s?populate=*`,
    },
    cabs: {
      rescheduleCab: `${gatewayURL}/pax2/v2/api/order/reschedule`,
    },
    helpAndSupport: {
      assistMe: `${secondaryGatewayUrl}/helpdesk/api/assist/me`,
      createTicket: `https://getgrab.freshdesk.com/api/v2/tickets/`,
      ticketListing: `${secondaryGatewayUrl}/helpdesk/api/ticket/list`,
    },
    appOperatingLocation: {
      locationDetails: `${gatewayURL}/pax2/v2/api/location/locationDetails`,
    },
    myCards: {
      getSavedCards: `${secondaryGatewayUrl}/pax2/v2/api/payment/stripe/getSavedCards/{{userId}}`,
      removeSavedCard: `${secondaryGatewayUrl}/pax2/v2/api/payment/stripe/removeSavedCard`,
      saveCardInitialization: `${secondaryGatewayUrl}/pax2/v2/api/payment/stripe/saveCardInitialization`,
      updateDefaultCard: `${secondaryGatewayUrl}/pax2/v2/api/payment/stripe/updateDefaultCard`,
    },
    auth: {
      // initiate: `${gatewayURL}/register/initiate`,
      // validate: `${gatewayURL}/register/validate`,
      // initiate: `${secondaryGatewayUrl}/register/initiate`,
      // validate: `${secondaryGatewayUrl}/register/validate`,
      // userValidate: `${gatewayURL}/login/otp`,
      initiate: `${gatewayURL}/register/initiate`,
      validate: `${gatewayURL}/register/validate`,
      newValidateAPi: `${gatewayURL}/login/local`,
      userValidate: `${gatewayURL}/login/otp`,
    },
    braintreePayment: {
      paymentProcess: `${secondaryGatewayUrl}/pax2/v2/api/payment/braintree/processPayment`,
    },
    cms: {
      alcoholAlert: `${serverURL}/alcohol-alerts?populate=*`,
    },
    geofence: {
      validate: `${gatewayURL}/pax2/v2/api/service/nearby`,
      getLoungeCoordinates: `${gatewayURL}/pax2/v2/api/service/geoLocation`,
      validateShop: `${gatewayURL}/pax2/v2/api/shops/geofence/validate`,
    },

    order: {
      orderCheckin: `${gatewayURL}/pax2/v2/api/order/checkin`,
    },
    //Register
    employeeRegister: `${secondaryGatewayUrl}/gw/api/employee/enroll/empId`,
    employeeUnRegister: `${secondaryGatewayUrl}/gw/api/employee/delist`,
    airportDetails: `${fisURL}/aodb/airportDetails`,

    ERC: {
      copyRight: `${cmsURL}/pages/ERCCopyRight`,
      toolsTraining: `${cmsURL}/page-sections/toolsTraining`,
      mysteryShops: `${cmsURL}/page-sections/mysteryShops`,
      reviewTracker: `${cmsURL}/page-sections/reviewTracker`,
      rewardsRecognition: `${cmsURL}/page-sections/rewardsRecognition`,
      customerExperienceHomepage: `${cmsURL}/page-sections/customerExperienceHomepage`,
      togetherAtT8: `${cmsURL}/page-sections/togetherAtT8`,
      meetPeopleOfT8: `${cmsURL}/page-sections/meetPeopleOfT8`,
      upcomingEvents: `${cmsURL}/page-sections/upcomingEvents`,
      newsLetter: `${cmsURL}/page-sections/newsLetter`,
      mobileOrdering: `${cmsURL}/page-sections/mobileOrdering`,
      culturalDiversity: `${cmsURL}/page-sections/culturalDiversity`,
      standardsReview: `${cmsURL}/page-sections/standardsReview`,
      newHireOrientation: `${cmsURL}/page-sections/newHireOrientation`,
      salesServiceTraining: `${cmsURL}/page-sections/salesServiceTraining`,
      coachsCorner: `${cmsURL}/page-sections/coachsCorner`,
      mysteryShopMetrics: `${cmsURL}/page-sections/mysteryShopMetrics`,
      mysteryShopsSummary: `${cmsURL}/page-sections/mysteryShopsSummary`,
      reviewTrackerResults: `${cmsURL}/page-sections/reviewTrackerResults`,
      clubExceptionalCriteria: `${cmsURL}/page-sections/clubExceptionalCriteria`,
      quarterlyWinners: `${cmsURL}/page-sections/quarterlyWinners`,
    },
    waitlist: {
      loungeStatus: `${gatewayURL}/pax2/v2/api/service/checkStatus`,
    },
    allergen: `${gatewayURL}/pax2/v2/api/products/masterAllergen`,
    tableNoValidate: `${gatewayURL}/pax2/v2/api/shops/validateTable`,
    eReceipt: `${gatewayURL}/pax2/v2/api/order/invoice`,
  },
  DisabledFlightStatus: [
    "CANCELLED",
    "GATEOPEN",
    "GATECLOSED",
    "FINALCALL",
    "DEPARTED",
    "ARRIVED",
  ],
  date: {},
  ux: {
    throttleControl: 500,
  },
  appDetails: {},
  auth: {},
  url: {
    serverURL,
  },
  imageUrlDomain: {
    imageURL: "",
  },
  ewt: {
    Departure: {
      Domestic: {
        terminalEntrance1To4: "T1DE_1-4",
        terminalEntrance5aTo9: "T1DE_5a-9",
        checkinCounter1To33: "T1CI_01-33",
        checkinCounter34To86: "T1CI_34-86",
        domLeft: "T1DS_Left",
        domRight: "T1DS_Right",
      },
      International: {
        terminalEntrance1To4: "T1DE_1-4",
        terminalEntrance5aTo9: "T1DE_5a-9",
        checkinCounter1To33: "T1CI_01-33",
        checkinCounter34To86: "T1CI_34-86",
        domLeft: "T1DS_Left",
        domRight: "T1DS_Right",
        internationSecurity: "T1IS",
        immigration: "T1IM",
      },
    },
    Arrival: {
      International: {
        visaOnArrival: "T1VI",
        emigration: "T1EM",
      },
    },
  },
  cart: {
    emptyMessage: [
      `Let's revamp your inventory!!!`,
      `Amazing products are just a click away...`,
      `I heard there's this superb deal going on...`,
      `Have you seen our latest collection !?`,
      `Not able to decide, let's take a walk on listing page :)`,
    ],
  },
  moreInfo: {
    relationType: [
      { value: "Father", label: "Father" },
      { value: "Mother", label: "Mother" },
      { value: "Spouse", label: "Spouse" },
      { value: "Sibling", label: "Sibling" },
      { value: "Friend", label: "Friend" },
      { value: "Others", label: "Others" },
    ],
  },
  myBooking: {
    cancellationReason: [
      { value: "r01", label: "Item not required" },
      { value: "r02", label: "Item booked by mistake" },
      { value: "r03", label: "Need to change payment method" },
      { value: "r04", label: "Others" },
    ],
  },
  travelParams: {
    area: [
      {
        id: 1,
        value: "Arrival",
        label: "Arrival",
      },
      {
        id: 2,
        value: "Departure",
        label: "Departure",
      },
      {
        id: 3,
        value: "Kerb Side",
        valueTwo: "Quad",
        label: "Kerb Side",
      },
    ],
    zone: [
      {
        id: 1,
        value: "Domestic",
        label: "Domestic",
      },
      {
        id: 2,
        value: "International",
        label: "International",
      },
    ],
  },
  deliveryOptions: {
    takeaway: "collect at store",
    deliveryAtGate: "collect at gate",
  },
  currency: {
    currencyCode: "INR",
    currencySymbol: "₹",
  },
  separators: {
    defaultSeparator: ",",
    customSeparator: {
      JFKLOCID: "",
    },
  },
  OATtype: {
    pay: {
      button: "Start your order",
    },
    view: {
      button: "Browse the menu",
    },
    order: {
      button: "Start your order",
    },
  },
  OATDineOption: {
    default: {
      title: "Dine-In or Takeaway?",
      subTitle: "Select one to continue.",
      option: [
        {
          title: "Dine In",
          value: "dinein",
          redirectURL: "/dine-in-table",
        },
        {
          title: "Takeaway",
          value: "takeaway",
          redirectURL: "/storefront",
        },
      ],
    },
  },
};

export const otpTimeout = 60;
export const resource = "paxapp";
export const channel = "SKATEBOARD";
export const defaultLanguage = "en";
export const languages = ["kn"];

// Browser-side cache entries that are allowed for every location.
// SEO/page-meta CMS pages are resolved on the Express server for crawlers.
export const CACHED_ROUTE_CONFIG = {};

// Locations currently allowed to use the caching below while it's being tested.
// Expand this list to roll caching out to all locations once validated.
export const CACHED_LOCATIONS = ["CPH"];

// Cached only for CACHED_LOCATIONS.
export const LOCATION_RESTRICTED_CACHED_ROUTE_CONFIG = {
  [config.api.navbar]: 60 * 60 * 1000,
  [config.api.footer]: 60 * 60 * 1000,
  [config.api.appEnvProps.envProps]: 30 * 60 * 1000,
  [config.api.appOperatingLocation.locationDetails]: 30 * 60 * 1000,
  [config.api.cms.alcoholAlert]: 15 * 60 * 1000,
};

export default config;
